<template>
  <layout-no-padding>
    <v-flex>
      <v-card>
        <v-container fluid>
          <v-layout row wrap class="vertical-center-container">
            <actions
              v-if="userAuthClass"
              :selectedCount="selectedCount"
              :selected="selected"
              :selectedAll="selectedAll"
              :pagination="pagination"
            ></actions>
            <v-spacer></v-spacer>
            <v-flex xs12 sm2 md4 class="text-xs-right">
              <v-tooltip bottom v-if="selected.length > 0 && !selectedAll">
                <v-btn flat color="grey" icon @click="selected = []; selectedAll = false" slot="activator">
                  <v-icon>remove_circle</v-icon>
                </v-btn>
                <span>Deselect All</span>
              </v-tooltip>
              <v-tooltip bottom>
                <v-menu
                  slot="activator"
                  bottom
                  left
                  transition="scale-transition"
                  max-height="600px"
                  origin="top right"
                  :close-on-content-click="false"
                  v-model="fieldChooserMenu"
                >
                  <v-btn flat icon color="grey" slot="activator">
                    <v-icon>filter_list</v-icon>
                  </v-btn>
                  <v-list>
                    <v-list-tile v-for="header of possibleHeaders" :key="header.value">
                      <v-list-tile-action>
                        <v-checkbox
                          :color="$store.state.global.pages[$route.name].color"
                          v-model="defaultHeaders"
                          :label="header.text"
                          :value="header.value"
                        ></v-checkbox>
                      </v-list-tile-action>
                    </v-list-tile>
                  </v-list>
                </v-menu>
                <span>Add & Remove Columns</span>
              </v-tooltip>
            </v-flex>

            <!-- SELECT ALL ALERT -->
            <v-alert
              v-if="selectedCount >= 10"
              :value="true"
              color="grey lighten-3"
              icon="notification_important"
              style="width: 100%; border-radius: 4px;"
              class="grey--text text--darken-2 py-1"
            >
              <div class="flex-container-center">
                <span>{{selectedCount}} items are selected.</span>
                <v-btn
                  v-if="selectedAll"
                  @click="selected = []; selectedAll = false;"
                  flat
                  color="grey"
                >Unselect all {{$vuetify.breakpoint.smAndUp ? `${selectedCount} items` : ''}}</v-btn>
                <v-btn
                  v-else
                  @click="selectedAll = true"
                  flat
                  :color="$store.state.global.pages.docket.color"
                >Select all {{$vuetify.breakpoint.smAndUp ? `${pagination.totalItems} items` : ''}}</v-btn>
              </div>
            </v-alert>
          </v-layout>
        </v-container>

        <v-data-table
          :items="tippingDockets"
          :headers="headers"
          :pagination.sync="pagination"
          :rows-per-page-items="pagination.rowsPerPageItems"
          :total-items="pagination.totalItems"
          v-model="selected"
          select-all
          :loading="loading"
          disable-initial-sort
        >
          <template slot="no-data">
            <div
              class="text-xs-center grey--text subheading"
            >No Tipping Dockets for the selected criteria.</div>
          </template>

          <template slot="items" slot-scope="props">
            <tipping-row
              :tippingDocket="props.item"
              :value="props.selected"
              :headers="headers"
              @input="toggleSelected"
              :key="props.item.id+props.item.updatedAt"
              :ref="props.item.id"
            ></tipping-row>
          </template>
        </v-data-table>

        <!-- DISPLAY TOTALS -->
        <!-- DISPLAY TOTALS -->
        <v-container fluid>
          <v-layout row wrap v-if="!!tippingDockets.length" class="grey--text"></v-layout>
        </v-container>
      </v-card>
    </v-flex>
  </layout-no-padding>
</template>

<script>
import Store from "@/store/computed/storeHelpers";
import TippingService from "@/services/requests/tippingService";
import TippingRow from "./tippingRow";
import Actions from "./tippingActions";
import CalculateTotal from "@/services/mixins/calculateTotal";
import StagingViewMixin from "../mixins/tippingMixin";
import HeaderFilters from "@/services/mixins/headerFilters";
import BuildTippingQuery from "../mixins/buildTippingQuery";
import { debounce } from "lodash";
export default {
  mixins: [HeaderFilters, StagingViewMixin, CalculateTotal, BuildTippingQuery],
  data() {
    return {
      searchTerm: "",
      loading: false,
      pagination: {
        descending: true,
        page: 1,
        rowsPerPage: 10,
        totalItems: 0,
        rowsPerPageItems: [10, 20, 40, 50]
      },
      totals: null,
      fieldChooserMenu: false
    };
  },
  methods: {
    //ADDS OR REMOVES OBJECTS FROM THE SELECTED ARRAY, DEPENDING ON WHETHER TRUE OR FALSE WAS EMMITED FROM TRIPROW COMPONENT
    toggleSelected(val) {
      if (val.value) {
        this.selected.push(val.object);
      } else {
        var index = this.selected.indexOf(val.object);
        this.selected.splice(index, 1);
      }
    },
    getTippingDockets(keepPage) {
      if (!keepPage) this.pagination.page = 1;
      //BUILD QUERY FROM MIXIN
      var payload = this.buildQuery();
      payload.pagination = this.pagination;
      this.retrieveTippingDockets(payload);
    },
    retrieveTippingDockets(payload) {
      this.loading = true;
      TippingService.getTippingDockets(payload)
        .then(result => {
          console.log(result);
          this.tippingDockets = result.data.result;
          this.pagination.totalItems = result.data.count;
          //this.totals = result.data.totals;
          this.loading = false;
        })
        .catch(err => {
          this.snackError();
          console.log(err);
          this.loading = false;
        });
    }
  },
  computed: {
    tippingDockets: Store.getSet({ store: "tipping", prop: "tippingDockets" }),
    filterBy: Store.getSet({ store: "tipping", prop: "filterBy" }),
    filterCol: Store.getSet({ store: "tipping", prop: "filterCol" }),
    filterCol2: Store.getSet({ store: "tipping", prop: "filterCol2" }),
    filterBy2: Store.getSet({ store: "tipping", prop: "filterBy2" }),
    filterStatus: Store.getSet({ store: "tipping", prop: "filterStatus" }),
    selected: Store.getSet({ store: "tipping", prop: "selected" }),
    selectedAll: Store.getSet({ store: "tipping", prop: "selectedAll" }),
    selectedCount() {
      if (this.selectedAll) {
        return this.pagination.totalItems;
      } else {
        return this.selected.length;
      }
    },
    showClosed: Store.getSet({ store: "shared", prop: "showClosed" }),
    selectedUserId: Store.getSet({ store: "shared", prop: "selectedUserId" }),
    projectId: Store.getSet({ store: "shared", prop: "projectId" }),
    dateRangeStart: Store.getSet({ store: "shared", prop: "dateRangeStart" }),
    dateRangeEnd: Store.getSet({ store: "shared", prop: "dateRangeEnd" }),
    dateRangeToggle: Store.getSet({ store: "shared", prop: "dateRangeToggle" }),
    fetchTippingDockets: Store.getSet({
      store: "tipping",
      prop: "fetchTippingDockets"
    })
  },
  mounted() {
    this.getTippingDockets();
  },
  beforeDestroy() {
    this.tippingDockets = [];
    this.selected = [];
  },
  components: {
    TippingRow,
    Actions
  },
  watch: {
    //TRIGGER REQUERIES OF DATA WHEN FILTERS CHANGE
    showClosed(val) {
      this.getTippingDockets();
    },
    selectedUserId(val) {
      this.getTippingDockets();
    },
    projectId(val) {
      this.getTippingDockets();
    },
    pagination(val) {
      this.getTippingDockets(true);
      this.$store.commit("tipping/setState", {
        prop: "pagination",
        value: val
      });
    },
    filterCol: debounce(function() {
      this.getTippingDockets();
    }, 200),
    filterBy: debounce(function() {
      this.getTippingDockets();
    }, 500),
    filterCol2: debounce(function() {
      this.getTippingDockets();
    }, 200),
    filterBy2: debounce(function() {
      this.getTippingDockets();
    }, 500),
    filterStatus() {
      this.selected = [];
      this.selectedAll = false;
      this.getTippingDockets();
    },
    dateRangeStart(val) {
      this.getTippingDockets();
    },
    dateRangeEnd(val) {
      this.getTippingDockets();
    },
    dateRangeToggle(val) {
      this.getTippingDockets();
    },
    fetchTippingDockets(val) {
      if (val) {
        this.fetchTippingDockets = false;
        this.getTippingDockets(true);
      }
    }
  }
};
</script>

<style>
</style>